export default __webpack_public_path__ + "static/media/detail_big_1_4.ac5e7223.png";